import React from 'react';
import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";
import { convertFromHTML, convertToHTML } from 'draft-convert';

export const DescriptionRichText = (props: {
    handleChange: (e: any) => void;
    description: string;
    isCanceled?: boolean;
    readOnly?: boolean; // Add readOnly prop
}) => {
    const [editorState, setEditorState] = React.useState(
        () => props.description ? EditorState.createWithContent(convertFromHTML(props.description)) : EditorState.createEmpty()
    );

    React.useEffect(() => {
        if (props.isCanceled) {
            setEditorState(EditorState.createWithContent(convertFromHTML(props.description)));
        }
    }, [props.isCanceled, props.description]);

    const handleChangeEditor = (data: any) => {
        const currentContentAsHTML = convertToHTML(data.getCurrentContent());
        setEditorState(data);
        if (!props.readOnly) { // Prevent calling handleChange if readOnly
            props.handleChange({
                target: {
                    name: 'description',
                    value: currentContentAsHTML
                }
            });
        }
    };

    return (
        <>
            <Editor
                editorState={editorState}
                onEditorStateChange={handleChangeEditor}
                readOnly={props.readOnly} // Pass the readOnly prop to the Editor
                toolbarHidden={props.readOnly} // Hide toolbar if readOnly
            />
        </>
    );
}
